"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _default(obj) {
  if (obj && _typeof(obj) === 'object') {
    for (var prop in obj) {
      if (obj[prop] === undefined || obj[prop] === null) Reflect.deleteProperty(obj, prop);
    }
  }

  return obj;
}